import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";

const WelcomeName = () => {
    const { instance } = useMsal();
    const [name, setName] = useState(null);
    const [username, setUsername] = useState(null);

    const activeAccount = instance.getActiveAccount();
    useEffect(() => {
        if (activeAccount) {
            setName(activeAccount.name);
            setUsername(activeAccount.username);
        } else {
            setName(null);
            setUsername(null);
        }
    }, [activeAccount]);

    if (name) {
        return <Typography textAlign="right" marginRight="1em"><b>{name}</b><br/>{username}</Typography>;
    } else {
        return null;
    }
};

export default WelcomeName;